import React from "react";
import { MdOutlineCancel } from "react-icons/md";

const CustomChip = ({ label, value, onRemove }) => {
  return (
    <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm hover:bg-red-50 hover:border-red-300 hover:text-red-600 cursor-pointer transition-all duration-150 group"
         onClick={onRemove}
         title={`Click to remove ${value || label}`}>
      <span className="truncate max-w-[120px]">{value || label}</span>
      <MdOutlineCancel className="text-lg group-hover:text-red-600 transition-all duration-150" />
    </div>
  );
};

export default CustomChip;
